import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function PhilosophySection() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-28 lg:py-36 px-6 bg-[#FAFAF8]" data-id="element-171">
      <div className="max-w-7xl mx-auto" data-id="element-172">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-173">
          {/* Image */}
          <div className="relative order-2 lg:order-1" data-id="element-174">
            <div className="aspect-[3/4] relative overflow-hidden" data-id="element-175">
              <img src="https://cdn.magicpatterns.com/uploads/5rzLbLcyxC8cx1mQWqD6AW/IMG_3632.png" alt={t('philosophy.founder')} className="w-full h-full object-cover object-center transition-all duration-700" data-id="element-176" />
              <div className="absolute inset-0 border-l-2 border-[#D4AF37] pointer-events-none" data-id="element-177"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2" data-id="element-178">
            <span className="text-[10px] tracking-[0.4em] text-[#D4AF37] block mb-8 uppercase font-light" data-id="element-179">
              {t('philosophy.label')}
            </span>

            <h2 className="font-serif text-5xl lg:text-6xl mb-3 font-light tracking-tight" data-id="element-180">
              {t('philosophy.title')}
            </h2>
            <p className="font-serif italic text-4xl mb-14 font-light text-gray-600" data-id="element-181">
              {t('philosophy.subtitle')}
            </p>

            <div className="space-y-6 text-gray-700 font-light leading-relaxed mb-14" data-id="element-182">
              <p className="text-base" data-id="element-183">{t('philosophy.text1')}</p>
              <p className="text-base" data-id="element-184">{t('philosophy.text2')}</p>
            </div>

            <div className="border-t border-[#D4AF37]/20 pt-8" data-id="element-185">
              <p className="font-serif text-2xl mb-2 font-light" data-id="element-186">
                {t('philosophy.founder')}
              </p>
              <p className="text-[10px] tracking-[0.3em] uppercase text-gray-500 font-light" data-id="element-187">
                {t('philosophy.role')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}